export default "__VITE_PUBLIC_ASSET__c6491222__"